module.exports = __webpack_public_path__ + "static/img/l4.d78711f9.png";